export const theme = {
  colors: {
    primary: "#0A3A6A", // Deep navy blue - high authority and trust
    secondary: "#2B5C8F", // Medium blue - secondary elements
    accent: "#8B9BB4", // Silver-blue - sophisticated highlights
    background: "#F4F7F6", // Very light off-white/gray - clean background
    surface: "#FFFFFF", // Pure white
    text: "#1A202C", // Near black - crisp, formal readability
    textLight: "#4A5568", // Medium gray - secondary copy
    border: "#E2E8F0", // Light silver - clean structure
    whatsapp: "#25D366", // Brand color remains
  },
  typography: {
    fontFamily: '"Montserrat", Arial, sans-serif',
    headings: {
      h1: "2.5rem",
      h2: "2rem",
      h3: "1.5rem",
    },
    body: "1rem",
    small: "0.875rem",
  },
  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
  },
  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "2rem",
    xl: "4rem",
    xxl: "8rem",
  },
}

export type Theme = typeof theme
